import React from 'react';

import {
  Header as TopListHeaderWrapper,
  HeaderContainer,
  ContentWrapper,
  MobileWrapper,
  IconWrapper,
  SmallTitle,
  Title,
} from './TopLists.style';
import { ReactComponent as TopListsIcon } from 'icons/fire-icon-header.svg';
import InViewObserver from 'components/utility/InViewObserver/InViewObserver';
import Layout from 'components/styled/Layout/Layout';
import TopBar from 'components/Header/TopBar/TopBar';
import Header from 'components/Header/Header';

const TopListsHeader: React.FC = () => {
  return (
    <InViewObserver
      render={({ inview }: any): JSX.Element => (
        <Header gradientColor="blue" inView={inview}>
          <TopBar
            inView={inview}
            isSticky
            gradientColor="blue"
            inNewDesign
            topic={['topLists']}
          />
          <Layout.MaxWidth>
            <HeaderContainer>
              <TopListHeaderWrapper>
                <IconWrapper>
                  <TopListsIcon />
                </IconWrapper>
                <ContentWrapper data-pw="header-top-bar">
                  <SmallTitle>Top Lists</SmallTitle>
                  <MobileWrapper>
                    <Title>What’s Trending</Title>
                  </MobileWrapper>
                </ContentWrapper>
              </TopListHeaderWrapper>
            </HeaderContainer>
          </Layout.MaxWidth>
        </Header>
      )}
    />
  );
};

export default TopListsHeader;
